//project constants
export const ProjectTitle = "Narendra Modi";
export const mainRouteInitial = "NarendraModi";
export const PageCountData = [10, 20, 30, 50, 100];
export const SMTechnoConsultantsPvtLtd = "2026 © S M Techno Consultants PVT LTD";
export const AllRightsReserved = " All Rights Reserved.";
export const Copyright = "Copyright";
export const InitialPageCount = "10";


